var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhiteRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.52481 29.1655C2.09814 29.1655 1.67148 29.0021 1.34648 28.6771C0.69481 28.0255 0.69481 26.9721 1.34648 26.3205L6.85481 20.8121L1.55481 15.3238C0.916477 14.6605 0.93481 13.6055 1.59648 12.9671C2.25981 12.3288 3.31481 12.3471 3.95314 13.0071L10.3898 19.6738C11.0215 20.3288 11.0131 21.3671 10.3698 22.0105L3.70314 28.6771C3.37814 29.0021 2.95148 29.1655 2.52481 29.1655Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteRightArrow);
export default __webpack_public_path__ + "static/media/white-right-arrow.34e3eb7ae4484af9319a0fff93f82d5e.svg";
export { ForwardRef as ReactComponent };